import { useState } from "react";
import { submitReview } from "../utils/api";

export default function ReviewModal({ booking, onClose, onSuccess }) {
  const [rating, setRating] = useState(0);
  const [hover, setHover] = useState(0);
  const [comment, setComment] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handleSubmit = async () => {
    if (rating === 0) { setError("Please select a star rating."); return; }
    setLoading(true); setError("");
    try {
      await submitReview(booking.shop_id, { rating, comment, booking_id: booking.id });
      onSuccess();
    } catch (err) { setError(err.response?.data?.message || "Could not submit review."); }
    finally { setLoading(false); }
  };

  return (
    <div style={styles.overlay} onClick={onClose}>
      <div style={styles.modal} onClick={(e) => e.stopPropagation()}>

        <div style={styles.header}>
          <h3 style={styles.title}>⭐ Rate Your Experience</h3>
          <button onClick={onClose} style={styles.closeBtn}>✕</button>
        </div>

        <div style={styles.bookingInfo}>
          <p style={styles.shopName}>✂️ {booking.shop_name}</p>
          <p style={styles.serviceInfo}>
            {booking.service_name || booking.service_names} · {new Date(booking.booking_date || booking.preferred_date).toLocaleDateString("en-IN", { day: "numeric", month: "short", year: "numeric" })}
          </p>
        </div>

        <div style={styles.starsSection}>
          <p style={styles.starsLabel}>How was your experience?</p>
          <div style={styles.stars}>
            {[1,2,3,4,5].map((star) => (
              <span key={star} onClick={() => setRating(star)}
                onMouseEnter={() => setHover(star)} onMouseLeave={() => setHover(0)}
                style={{ ...styles.star, color: star <= (hover || rating) ? "#f5a623" : "var(--border)" }}>
                ★
              </span>
            ))}
          </div>
          <p style={styles.ratingText}>
            {rating === 0 && "Tap a star to rate"}
            {rating === 1 && "😞 Poor"}
            {rating === 2 && "😐 Fair"}
            {rating === 3 && "🙂 Good"}
            {rating === 4 && "😊 Very Good"}
            {rating === 5 && "🤩 Excellent!"}
          </p>
        </div>

        <textarea placeholder="Write about your experience... (optional)"
          value={comment} onChange={(e) => setComment(e.target.value)}
          style={styles.textarea} rows={3} />

        {error && <div style={styles.error}>{error}</div>}

        <div style={styles.btnRow}>
          <button onClick={onClose} style={styles.cancelBtn}>Cancel</button>
          <button onClick={handleSubmit} style={styles.submitBtn} disabled={loading}>
            {loading ? "Submitting..." : "⭐ Submit Review"}
          </button>
        </div>
      </div>
    </div>
  );
}

const styles = {
  overlay: { position: "fixed", top: 0, left: 0, right: 0, bottom: 0, background: "rgba(0,0,0,0.7)", display: "flex", alignItems: "center", justifyContent: "center", zIndex: 1000, padding: "20px" },
  modal: { background: "var(--bg-card)", borderRadius: "16px", padding: "24px", width: "100%", maxWidth: "400px", border: "1px solid var(--border)", boxShadow: "0 20px 60px rgba(0,0,0,0.5)" },
  header: { display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "16px" },
  title: { fontSize: "1.1rem", fontWeight: "bold", color: "white", margin: 0 },
  closeBtn: { background: "none", border: "none", fontSize: "18px", cursor: "pointer", color: "var(--text-muted)" },
  bookingInfo: { background: "var(--bg-secondary)", borderRadius: "10px", padding: "12px 14px", marginBottom: "20px", border: "1px solid var(--border)" },
  shopName: { fontWeight: "bold", margin: "0 0 4px", color: "white", fontSize: "14px" },
  serviceInfo: { color: "var(--text-muted)", fontSize: "12px", margin: 0 },
  starsSection: { textAlign: "center", marginBottom: "20px" },
  starsLabel: { color: "var(--text-secondary)", fontSize: "13px", marginBottom: "12px" },
  stars: { display: "flex", justifyContent: "center", gap: "8px", marginBottom: "8px" },
  star: { fontSize: "36px", cursor: "pointer", transition: "color 0.1s" },
  ratingText: { color: "var(--text-muted)", fontSize: "13px", margin: 0, height: "20px" },
  textarea: { width: "100%", padding: "12px", borderRadius: "8px", fontSize: "14px", resize: "vertical", fontFamily: "inherit", marginBottom: "14px", boxSizing: "border-box" },
  error: { background: "rgba(233,69,96,0.1)", color: "#ff6b6b", padding: "10px", borderRadius: "8px", fontSize: "13px", marginBottom: "14px", border: "1px solid rgba(233,69,96,0.3)" },
  btnRow: { display: "flex", gap: "10px" },
  cancelBtn: { flex: 1, padding: "12px", background: "none", border: "1px solid var(--border)", color: "var(--text-secondary)", borderRadius: "8px", cursor: "pointer", fontSize: "14px" },
  submitBtn: { flex: 2, padding: "12px", background: "var(--accent)", color: "white", border: "none", borderRadius: "8px", cursor: "pointer", fontSize: "14px", fontWeight: "bold" },
};